import {api} from '../_services'

const state = {
    error: '',
    loading: false,
    reports: []
}

const actions = {
    async loadInstagramReports ({commit}) {
        commit('onRequest')
        try {
            const res = await api.instagramReports()
            commit('onSuccess', {res})
        } catch (error) {
            commit('onError', error)
        }
    }
}

const getters = {
    getInstagramReports: state => {
        return state.reports
    }
}

const mutations = {
    onRequest (state) {
        state.loading = true
    },
    onSuccess (
        state,
        {
            res: {data}
        }
    ) {
        state.reports = data.reports
        state.loading = false

    },
    onError (state, error) {
        state.loading = false
        state.error = error
    }
}

export const reports = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
